import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NWBarChart, NWHorizontalBarChart, SubTitle } from 'components';
import './BarChart.scss';

const BarChart = ({ title, data, layout }) => (
  <div className="nw-page-fundfactsheet__allocation">
    <SubTitle title={(<FormattedMessage id={title} />)} />
    <div
      className={`nw-page-fundfactsheet__barChart ${layout !== 'horizontal' ? 'nw-page-fundfactsheet__barChart--vertical' : ''}`}
      style={layout === 'horizontal' ? { height: data ? (data.length * 2 - 1) * 16 : 0, minHeight: 80 } : {}}
    >
      {
            layout === 'horizontal'
              ? (
                <NWHorizontalBarChart
                  data={data}
                  containerWidth="98%"
                />
              )
              : (
                <NWBarChart
                  data={data}
                />
              )
        }
    </div>
  </div>
);

export default BarChart;
